import { isEmpty } from "lodash";
import { IAbsenceRequestHistoryEntryDetails } from "src/Pages/Company/Absences/AbsenceRequest/AbsenceRequest.models";
import {
  AbsenceTypeHistoryEntryDetailsTypes,
  IAbsenceTypeHistoryItemDetails,
} from "src/Pages/Company/Absences/AbsenceType/AbsenceType.models";

export default (
  details: IAbsenceRequestHistoryEntryDetails | IAbsenceTypeHistoryItemDetails
) => {
  if (!details || isEmpty(details)) return [];

  const rows: any[] = [];

  Object.entries(details).forEach(([key, value]) => {
    if (value === null) return;

    // Special handling for CONFIGURATION_OPTIONS
    if (key === AbsenceTypeHistoryEntryDetailsTypes.CONFIGURATION_OPTIONS) {
      const configOptions = value;

      Object.entries(configOptions).forEach(
        ([configKey, configValue]: [string, any]) => {
          if (configValue && configKey !== "submitLimitations") {
            rows.push({
              id: `${key}.${configKey}`,
              parentId: key,
              configKey,
              before: configValue.before,
              after: configValue.after,
            });
          } else if (configKey === "submitLimitations" && configValue) {
            // Handle submitLimitations separately - create rows for prior and advance
            Object.entries(configValue).forEach(
              ([limitationType, limitationValue]: [string, any]) => {
                if (
                  limitationValue &&
                  limitationValue.before !== undefined &&
                  limitationValue.after !== undefined
                ) {
                  rows.push({
                    id: `${key}.${configKey}.${limitationType}`,
                    parentId: key,
                    configKey: "submitLimitations",
                    submitLimitationType: limitationType, // "prior" or "advance"
                    before: limitationValue.before,
                    after: limitationValue.after,
                  });
                }
              }
            );
          }
        }
      );
    }
    // Special handling for NOTIFICATIONS_CONFIGURATION
    else if (
      key === AbsenceTypeHistoryEntryDetailsTypes.NOTIFICATIONS_CONFIGURATION
    ) {
      const notificationConfig = value as any;

      Object.entries(notificationConfig).forEach(
        ([groupKey, groupValue]: [string, any]) => {
          if (groupValue && typeof groupValue === "object") {
            Object.entries(groupValue).forEach(
              ([notificationKey, notificationValue]: [string, any]) => {
                if (
                  notificationValue &&
                  notificationValue.before !== undefined &&
                  notificationValue.after !== undefined
                ) {
                  rows.push({
                    id: `${key}.${groupKey}.${notificationKey}`,
                    parentId: key,
                    groupKey,
                    notificationKey,
                    before: notificationValue.before,
                    after: notificationValue.after,
                  });
                }
              }
            );
          }
        }
      );
    } else {
      // Regular handling for other fields
      rows.push({
        id: key,
        ...value,
      });
    }
  });

  return rows;
};
